import { useI18n } from '../i18n';
import { LEVEL_CAP, levelColor, xpToLevel } from '../utils/level';
import './LevelBadge.css';

interface Props {
  /** Toplam XP — verildiyse level otomatik hesaplanır. */
  xp?: number;
  /** Doğrudan level — xp verilmediyse kullanılır. */
  level?: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function LevelBadge({ xp, level, size = 'md', showLabel = true }: Props) {
  const { t } = useI18n();
  const computed = xp !== undefined ? xpToLevel(xp) : null;
  const lvl = computed?.level ?? level ?? 1;
  const c = levelColor(lvl);
  return (
    <div
      className={`level-badge level-badge--${size}`}
      style={{ borderColor: c.ring, background: c.bg, color: c.text }}
    >
      <span
        className="level-badge-ring"
        style={{ borderColor: c.ring, color: c.text, ['--bg' as any]: 'var(--card-bg, #fff)' }}
      >
        {lvl}
      </span>
      {showLabel && <span>{t.profile.level}</span>}
    </div>
  );
}

interface CardProps {
  xp: number;
}

export function LevelCard({ xp }: CardProps) {
  const { t } = useI18n();
  const { level, xpIntoLevel, xpForNext } = xpToLevel(xp);
  const c = levelColor(level);
  const pct = xpForNext > 0 ? Math.min(100, (xpIntoLevel / xpForNext) * 100) : 100;
  const isMax = level >= LEVEL_CAP;

  return (
    <div className="level-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <LevelBadge level={level} size="lg" showLabel />
        <div style={{ fontSize: 12, opacity: 0.75 }}>
          {isMax ? t.profile.levelMaxed : `${xpIntoLevel.toLocaleString()} / ${xpForNext.toLocaleString()} XP`}
        </div>
      </div>
      <div className="level-progress">
        <div
          className="level-progress-fill"
          style={{ width: `${pct}%`, background: `linear-gradient(90deg, ${c.ring}, ${c.text})` }}
        />
      </div>
      {!isMax && (
        <div className="level-card-row">
          <span>{t.profile.xpToNext.replace('{amount}', (xpForNext - xpIntoLevel).toLocaleString())}</span>
          <span>{xp.toLocaleString()} XP</span>
        </div>
      )}
    </div>
  );
}
